var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { FormattedCurrency, FormattedDate } from "@irati/utils/lang";
import { Para } from "@irati/ui/src/Labels";
var Flex = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var RewardFlex = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  max-height: 100px;\n  flex-direction: column;\n"], ["\n  display: flex;\n  max-height: 100px;\n  flex-direction: column;\n"])));
var StyledPara = styled(Para)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 14px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"], ["\n  font-size: 14px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"])));
var columns = function (formatMessage) { return [
    {
        Header: formatMessage({ id: "admin.reporting.rewardOrders.orderId" }),
        id: "uuid",
        minWidth: 120,
        accessor: function (_a) {
            var uuid = _a.uuid;
            return React.createElement(StyledPara, null, uuid);
        }
    },
    {
        Header: formatMessage({ id: "admin.reporting.rewardOrders.senderHeading" }),
        id: "sender",
        minWidth: 120,
        accessor: function (_a) {
            var createdBy = _a.createdBy;
            return React.createElement(StyledPara, null, createdBy.email);
        }
    },
    {
        Header: formatMessage({ id: "admin.reporting.rewardOrders.receiversHeading" }),
        id: "recipients",
        minWidth: 120,
        accessor: function (_a) {
            var recipients = _a.recipients;
            return (React.createElement(Flex, null, recipients.results.map(function (recipient, i) { return (React.createElement(StyledPara, { key: i }, recipient.email)); })));
        }
    },
    {
        Header: formatMessage({ id: "admin.reporting.rewardOrders.rewardDetail" }),
        id: "rewards",
        minWidth: 120,
        accessor: function (_a) {
            var reward = _a.reward, custom = _a.custom;
            return (React.createElement(RewardFlex, null,
                React.createElement(StyledPara, null, reward ? reward.header : custom)));
        }
    },
    {
        Header: formatMessage({ id: "admin.reporting.rewardOrders.quantity" }),
        id: "quantity",
        maxWidth: 60,
        accessor: function (_a) {
            var quantity = _a.quantity;
            return React.createElement(StyledPara, null, quantity);
        },
        style: { maxWidth: 60 }
    },
    {
        Header: formatMessage({ id: "admin.reporting.rewardOrders.totalCost" }),
        id: "totalCost",
        maxWidth: 120,
        accessor: function (_a) {
            var costTotal = _a.costTotal;
            if (!costTotal) {
                return null;
            }
            return React.createElement(FormattedCurrency, { isCents: false, currency: costTotal.currency, value: costTotal.amount });
        },
        style: { maxWidth: 120 }
    },
    {
        Header: formatMessage({ id: "admin.reporting.rewardOrders.purchaseDate" }),
        id: "updatedAt",
        maxWidth: 120,
        accessor: function (_a) {
            var updatedAt = _a.updatedAt;
            return React.createElement(FormattedDate, { value: updatedAt });
        },
        style: { maxWidth: 120 }
    }
]; };
export default columns;
var templateObject_1, templateObject_2, templateObject_3;
